import IconEosLoading from "~icons/eos-icons/loading.svg";

interface LoadingProps {
  fullScreen?: boolean;
}

export function Loading(props: LoadingProps = {}) {
  const { fullScreen = false } = props;

  return (
    <div
      class={`flex items-center justify-center ${
        fullScreen
          ? "fixed inset-0 z-[9999] h-screen w-screen"
          : "absolute inset-0 h-full max-h-screen w-full"
      }`}
    >
      <IconEosLoading class="text-general-main h-10 w-10" />
    </div>
  );
}
